import React, { useEffect, useState } from "react";
import { Plus, Trash2, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";
import { api } from "@/lib/api";

export default function TestimonialsTab() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState(null);
  const [saving, setSaving] = useState(false);

  const load = () => api.get("/testimonials?include_inactive=true").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const save = async () => {
    if (!form.name || !form.text) { toast.error("Preencha nome e depoimento."); return; }
    setSaving(true);
    try {
      if (form.id) await api.put(`/testimonials/${form.id}`, form);
      else await api.post("/testimonials", form);
      toast.success("Depoimento salvo!");
      setForm(null); load();
    } catch { toast.error("Falha ao salvar"); }
    finally { setSaving(false); }
  };
  const remove = async (id) => { if (!window.confirm("Excluir?")) return; await api.delete(`/testimonials/${id}`); load(); };

  return (
    <div>
      <div className="flex justify-between items-center mb-5">
        <p className="text-sm text-[var(--text-muted)]">Depoimentos ficam ocultos no site até serem cadastrados.</p>
        <Button onClick={() => setForm({ brand: "stamp", name: "", role: "", text: "", active: true })} data-testid="add-testimonial-button" className="btn-primary font-bold"><Plus size={16} className="mr-1" /> Novo</Button>
      </div>
      {form && (
        <div className="card-surface p-6 space-y-4 mb-6 max-w-lg">
          <Select value={form.brand} onValueChange={(v) => setForm({ ...form, brand: v })}>
            <SelectTrigger className="bg-[var(--bg-secondary)]"><SelectValue /></SelectTrigger>
            <SelectContent><SelectItem value="stamp">K8 Stamp</SelectItem><SelectItem value="sports">K8 Sports</SelectItem></SelectContent>
          </Select>
          <div className="grid grid-cols-2 gap-3">
            <div><Label>Nome</Label><Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="bg-[var(--bg-secondary)]" /></div>
            <div><Label>Cargo/empresa</Label><Input value={form.role} onChange={(e) => setForm({ ...form, role: e.target.value })} className="bg-[var(--bg-secondary)]" /></div>
          </div>
          <div><Label>Depoimento</Label><Textarea value={form.text} onChange={(e) => setForm({ ...form, text: e.target.value })} className="bg-[var(--bg-secondary)]" /></div>
          <label className="flex items-center gap-2"><Switch checked={form.active} onCheckedChange={(v) => setForm({ ...form, active: v })} /> Exibir no site</label>
          <div className="flex gap-2">
            <Button onClick={save} disabled={saving} data-testid="testimonial-save" className="btn-primary font-bold flex-1">{saving ? <Loader2 className="animate-spin mr-2" size={16} /> : null} Salvar</Button>
            <Button variant="ghost" onClick={() => setForm(null)}>Cancelar</Button>
          </div>
        </div>
      )}
      <div className="grid md:grid-cols-2 gap-4">
        {items.map((t) => (
          <div key={t.id} className="card-surface p-5" data-testid={`admin-testimonial-${t.id}`}>
            <div className="flex justify-between items-start">
              <div><span className="text-xs px-1.5 py-0.5 rounded bg-white/10">{t.brand}</span>{!t.active && <span className="ml-2 text-xs text-red-400">oculto</span>}</div>
              <div className="flex gap-2">
                <Button size="sm" variant="outline" onClick={() => setForm(t)} className="border-[var(--border)] text-xs">Editar</Button>
                <Button size="sm" variant="outline" onClick={() => remove(t.id)} className="border-[var(--border)] text-red-400"><Trash2 size={14} /></Button>
              </div>
            </div>
            <p className="text-sm mt-3">“{t.text}”</p>
            <div className="text-xs text-[var(--text-muted)] mt-2">{t.name} {t.role && `· ${t.role}`}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
